// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1I-qZ","selects":"Documents_selects__cVHd3"};